<template>
  <div>
    <img v-if="isImage" :src="attachment.url" class="object-cover max-w-sm" />
    <div v-else class="px-2 rounded-lg flex flex-col">
      <a :href="attachment.url" class="text-red hover:text-red" target="_blank">
        <span class="font-medium">
          {{ name }}
        </span>
        <span>
          <svg class="h-5 w-5 inline" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </a>
<!--      <span class="text-gray-500 text-sm">(15 kb)</span>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "AttachmentDisplay",
  props: {
    attachment: {
      type: Object,
      required: true
    }
  },
  computed: {
    isImage() {
      return this.attachment.url.includes("/images");
    },
    name() {
      return this.attachment.key.substring(
        this.attachment.key.indexOf("/") + 1
      );
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
